import { render, staticRenderFns } from "./BeginningInventory.vue?vue&type=template&id=37f915eb&scoped=true&"
import script from "./BeginningInventory.vue?vue&type=script&lang=js&"
export * from "./BeginningInventory.vue?vue&type=script&lang=js&"
import style0 from "./BeginningInventory.vue?vue&type=style&index=0&id=37f915eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f915eb",
  null
  
)

export default component.exports